import React, { useEffect } from "react";

import getContentById from "../../../../shared/utils/getContentById";
import _ from "lodash";
import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, {
  animationCleanUp,
} from "../../../../../animations/worldcup/matchup";

import assets from "./assets";
import getOptaCountryCode from "../../../../shared/utils/getOptaCountryCode";
import { useTranslation } from "react-i18next";
// import outroVideo9x16 from "../../../assets/outros/outro_playoffs_9x16.webm";
import Image from "../../../../shared/components/Image";
import { getShortPlayerName } from "../../../../shared/feeds/worldcup/playerHelper";
import { WcBgCircle } from "../../../../shared/backgrounds/WcBgCircle/Index";
import ProgressBar from "../../../../shared/components/ProgressBar";
import i18n from "i18next";
import { getDynamicLogoPath } from "../../../../shared/utils/functions";
import { MatchScoreWidget } from "../../_partials/MatchScoreWidget/Index";
import Last10GamesChart from "../../../../shared/components/LineChart/Index";
import { getTeamLast10StatsSeason, getTeamStats, getTeamStatsSeason } from "../../../../shared/utils/opta/statsHandler";

require("./style/style.scss");
require("./style/animation.scss");

const translations = {
  Group: "Gruppe",
};

const Index = (props) => {
  const refs = {
    player: React.createRef(),
    team: React.createRef(),
  };

  const {
    animation,
    data,
    images: Images,
    apiSetup,
    mode,
    format,
    isTimeline,
  } = props;

  const id = `${_.get(data, "template_name", "")}_${_.get(data, "uuid", "")}`;
  const { t } = useTranslation();

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          refs,
          data,
          animation,
          mode,
          id,
          format,
          apiSetup,
          templateName: data?.template_name,
        });
      }
    }

    //handle outro video BEGIN
    // if (mode === "video" && !isTimeline) {
    //   const outroVideo = $(`#${id} video.outro-optional-video`);
    //   outroVideo.get(0).addEventListener(
    //     "loadedmetadata",
    //     function () {
    //       const that = this;
    //       setTimeout(() => {
    //         outroVideo?.css("opacity", 1);
    //         this.currentTime = 0;
    //         that.play();
    //       }, frontendCfg.showOutroAfter);
    //     },
    //     false,
    //   );
    // }
    //handle outro video END

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const templateData = _.get(data, "data");
  const { options, fields, dynamic } = templateData;
  const matchInfo = _.get(dynamic, "matchInfo");
  const matchStats = _.get(dynamic, "matchStats");
  const liveData = _.get(dynamic, "liveData");
  const matchDetails = _.get(liveData, "matchDetails");
  const matchStatus = _.get(matchDetails, "matchStatus");
  const last10GamesStandings = _.get(dynamic, "last10GamesStandings");
  const week = _.get(dynamic, "week");
  const totalStandingTeams = _.get(dynamic, "totalStandingTeams");

  const teamColors = {
    home: matchStats?.liveData?.lineUp
      ? matchStats?.liveData?.lineUp[0]?.kit?.colour1 === "#000000" ? '#f1cf0e' : matchStats?.liveData?.lineUp[0]?.kit?.colour1
      : "#f1cf0e",
    away: matchStats?.liveData?.lineUp
      ? matchStats?.liveData?.lineUp[1]?.kit?.colour1 === "#000000" ? "#df2a27" : matchStats?.liveData?.lineUp[1]?.kit?.colour1
      : "#df2a27",
  };
  const backgroundImage = getMainBackground(format, _.get(dynamic, "teamSide"));

  const competitionId = matchInfo?.competition?.id;

  const homeTeam = matchInfo?.contestant?.[0];
  const awayTeam = matchInfo?.contestant?.[1];

  const statsType = getContentById("statsType", fields);
  const homeStats = _.get(matchStats, "liveData.lineUp.0.stat");
  const awayStats = _.get(matchStats, "liveData.lineUp.1.stat");
  const scores = _.get(matchStats, "liveData.matchDetails.scores");

  const statsMappingHome = getTeamStats(homeStats, statsType);
  const statsMappingAway = getTeamStats(awayStats, statsType);

  const teamCompare = _.get(dynamic, "teamCompare");
  const teamRanking = _.get(dynamic, "ranking");

  const statsHome = _.get(teamCompare, "home");
  const statsAway = _.get(teamCompare, "away");

  const statsMappingHomeTeam = getTeamLast10StatsSeason(statsHome, statsType);
  const statsMappingAwayTeam = getTeamLast10StatsSeason(statsAway, statsType);

  const headline = t("Matchday position", {keyPrefix: "templates"});

  const filteredLast10GamesStandings = last10GamesStandings?.map((item) => ({
    [homeTeam.id]: item[homeTeam?.id],
    [awayTeam.id]: item[awayTeam?.id],
  }));


  const totalStanding = _.get(dynamic, "standing");
  const homeRankings = _.get(dynamic, "homeRankings");
  const awayRankings = _.get(dynamic, "awayRankings");

  const totalStandingHome = totalStanding?.find((st) => st.contestantId === homeTeam.id);
  const totalStandingAway = totalStanding?.find((st) => st.contestantId === awayTeam.id);

  const homeStandingHome = homeRankings?.find((st) => st.contestantId === homeTeam.id);
  const awayStandingHome = homeRankings?.find((st) => st.contestantId === awayTeam.id);

  const homeStandingAway = awayRankings?.find((st) => st.contestantId === homeTeam.id);
  const awayStandingAway = awayRankings?.find((st) => st.contestantId === awayTeam.id);

  const stats = [
    {
      type: 'Points',
      home: totalStandingHome?.points,
      away: totalStandingAway?.points,
    },
    {
      type: 'Goals',
      home: totalStandingHome?.goalsFor,
      away: totalStandingAway?.goalsFor,
    },
    {
      type: 'Goals Conceded',
      home: totalStandingHome?.goalsAgainst,
      away: totalStandingAway?.goalsAgainst,
    },
    {
      type: 'Points Home',
      home: homeStandingHome?.points,
      away: awayStandingHome?.points,
    },
    {
      type: 'Points Away',
      home: homeStandingAway?.points,
      away: awayStandingAway?.points,
    },
  ]
  const lng = i18n?.language;
  return (
    <div
      id={id}
      className={`T_${_.get(data, "template_name", "")} ${animation ? "animation" : ""} side-${_.get(dynamic, "teamSide")}`}
    >
      <TemplateBlock>
        <Backgrounds bg1={backgroundImage} loop={true} />
        <div className={"wc-content wc-content-v2"}>
          <ProgressBar height={"8px"} />
          <div className={"wc-bg-content new-card"}>
            <div className={"left-block-side"}>
              <div className={"competition-positioner"}>
                <div className={"competition-logo-container"}>
                  <Image
                    src={`/images/dynamic/soccer/competition/${competitionId}.svg`}
                  />
                </div>
                <div className={"competition-name"}>
                  {lng === 'de' ? `${week ? week : "26"}. ${t("Matchday")}` : `${t("Matchday")} ${week ? week : "26"}`}
                </div>
              </div>

              <div className={"team-stats"}>
                {/* {statsMappingHome?.map((statRowHome, index) => {
                  const statRowAway = statsMappingAway?.[index];
                  return (
                    <div key={statRowHome.type} className={"stat-row"}>
                      <div className={"stat-home"}>
                        {statRowHome?.value || "0"}
                      </div>
                      <div className={"stat-label"}>
                        {t(statRowHome?.type, { keyPrefix: "stats" })}
                      </div>
                      <div className={"stat-away"}>
                        {statRowAway?.value || "0"}
                      </div>
                    </div>
                  );
                })} */}
                <div className="team-logo-wrapper">
                  <div className={"team-logo-container home"}>
                    <Image
                      className="team-logo"
                      src={getDynamicLogoPath({ team: homeTeam, competitionId })}
                    />
                  </div>
                  <div className="team-stats-title">
                    {/* Season stats */}
                    {t('Season Stats', { keyPrefix: "templates" })}
                  </div>
                  <div className={"team-logo-container away"}>
                    <Image
                      className="team-logo"
                      src={getDynamicLogoPath({ team: awayTeam, competitionId })}
                    />
                  </div>
                </div>


                {stats.map((stats, index) => {

                  return (
                    <div key={stats.type} className={"stat-row"}>
                      <div className={"stat-home"}>{stats?.home || "0"}</div>
                      <div className={"stat-label"}>
                        {t(stats?.type, { keyPrefix: "stats" })}
                      </div>
                      <div className={"stat-away"}>{stats?.away || "0"}</div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className={"right-block-side"}>
              <div className={"heatmap-block"}>
                <div className={"main-header green-glow"}>{headline}</div>
                <div className={"qatar-logo"}>
                  <img src={assets.of_logo} />
                </div>
              </div>
              <div className={"pitch-container"}>
                <Last10GamesChart
                  competitionId={competitionId}
                  homeTeam={homeTeam}
                  awayTeam={awayTeam}
                  standings={filteredLast10GamesStandings}
                  teamColors={teamColors}
                  week={week}
                  totalStandingTeams={totalStandingTeams}
                  strokeWidth={0}
                  isOf={true}
                />
              </div>
            </div>
          </div>
        </div>
      </TemplateBlock>
    </div>
  );
};

const getMainBackground = (format, side) => {
  return _.get(assets, `background_1920`);
};

export default Index;
